import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { updateUiAction } from 'actions/uiActions'
import { updateMarkupAction, deleteMarkupAction } from 'actions/markupActions'
import { messageAction } from 'actions/messageActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from 'rc-slider'
import { DEFAULT_LABEL_SIZES, DEFAULT_LABEL_MARKS } from 'helpers/globals'
import { FillPicker, BorderPicker } from 'components/MarkupDetails/ColorPicker'

const mapStateToProps = ({ map: { markups, zoom }, currentEntity: { id } }) => {
  const currentLabel = markups.find(m => m.id === id)
  return { currentLabel, zoom }
}

const convertToIndex = (size) => {
  const index = DEFAULT_LABEL_SIZES.indexOf(size)
  return index === -1 ? null : index + 1
}

class LabelDetails extends React.Component {
  render() {
    const { currentLabel, currentLabel: { id, text, locked, overlay, dimensions, size }, zoom, updateUiAction,
      updateMarkupAction, deleteMarkupAction, classes } = this.props

    return (
      <div className={classes.labelDetails}>
        <div className={classes.topUiControls}>
          <a onClick={_ => updateUiAction({ sidebarView: 'cameraList' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            All Project Items
          </a>
          <a
            onClick={_ => {
              if (locked) {
                this.props.messageAction('generalError', 'Cannot delete locked Label. Right click to unlock.')
              } else if (window.confirm(`Are you sure you want to delete \"${text}\"?`)){
                overlay.setMap(null)
                deleteMarkupAction(id)
              }
            }}
            className={classes.destroyLabelButton}>
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <div className={classes.container}>
          <div title={'Text'} className={classes.label}>Text</div>
          <div className={classes.textWrapper}>
            <input
              type='text'
              className={classes.labelTextInput}
              onChange={({ target: { value } }) => {
                updateMarkupAction(id, { text: value })
                overlay.text = value
                overlay.spanElement.textContent = value
              }}
              value={text || ''}
            />
          </div>
          <div className={classes.labelActions}>
            <a onClick={_ => updateMarkupAction(id, { locked: !locked })}>
              <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} className={classes.lockButton} />
            </a>
            <a onClick={_ => overlay.map.fitBounds(overlay.rectangle.getBounds())} >
              <FontAwesomeIcon icon='map-marker-alt' className={classes.targetButton} />
            </a>
          </div>
        </div>
        <div className={classes.container}>
          <div title={'Size'} className={classes.label}>Size</div>
          <div className={classes.sliderContainer}>
            <Slider
              min={1}
              max={DEFAULT_LABEL_SIZES.length}
              value={convertToIndex(size) || Math.ceil(DEFAULT_LABEL_SIZES.length / 2)}
              onChange={size => {
                updateMarkupAction(id, { size: DEFAULT_LABEL_SIZES[size - 1] })
                overlay.changeSize(DEFAULT_LABEL_SIZES[size - 1])
              }}
              marks={DEFAULT_LABEL_MARKS}
              step={null}
            />
          </div>
        </div>
        <div className={classes.container} style={{ marginTop: '1rem' }}>
          <span className={classes.colorLabel}>Fill</span>
          <FillPicker {...{ currentMarkup: currentLabel, updateMarkupAction }} />
        </div>
        <div className={classes.container}>
          <span className={classes.colorLabel}>Text</span>
          <BorderPicker {...{ currentMarkup: currentLabel, updateMarkupAction }} />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateMarkupAction, deleteMarkupAction, messageAction })(injectSheet(style)(LabelDetails))



// WEBPACK FOOTER //
// ./src/components/LabelDetails/index.js